<template>
  <span>
    a
    <v-text-field v-if="!readonly"
      class="d-inline-block mx-2" required dense hide-details
      append-icon="" height="14px" style="min-width: 120px;"
      v-model="level"
      @change="onQueryChange"/>
    <span v-else>{{level}} </span>
    account
  </span>
</template>

<script>
export default {
  name: "Subscription",
  props: {
    onQueryChange: {
      type: Function,
      required: true,
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      level: 'freeAccount'
    }
  },
  created() {
    this.onChangeInitialConfig();
  },
  methods: {
    onChangeInitialConfig() {
      if (this.initialConfig.level) {
        this.level = this.initialConfig.level;
      }
    },
    getQuery() {
      return {
        level: this.level
      }
    }
  },
  watch: {
    initialConfig() {
      this.onChangeInitialConfig();
    }
  }
}
</script>

<style scoped>

</style>